<div class="pos-relative"
     (offClick)="close()"
     [offClickOff]="!isOpen">
    <div class="pos-relative"
         (click)="open()">
        <input class="input"
               type="text"
               cy-Date
               [attr.name]="name"
               [required]="required"
               [attr.readonly]="readonly"
               [muiInput]="placeholder || ''"
               [(ngModel)]="inputFieldValue"
               inputMask
               mask="99/99/9999">
        <div class="pos-absolute top-0 bottom-0 flex flex-middle flex-justify-center pe-none input-icon">
            <i class="icon-calendar"></i>
        </div>
    </div>
    @if(options) {
    <div class="pos-absolute pos-relative-s top-100 left-0 z-9 w-12 _hide-up-container">
        <div class="ng-hide"
             [toggleClass]="'!ng-hide'"
             [toggleClassBy]="[toggleGroup, 0]">
            <calendar [options]="options"
                      (validateDay)="onValidate($event)"
                      (modelChange)="onValueChange($event)"
                      [(ngModel)]="value"></calendar>
        </div>
    </div>
    }
</div>